import { configureStore }           from '@reduxjs/toolkit'
import { workflowSlice }            from './dataReducers/workflowSlice';
import { cmsPilotSlice }            from './dataReducers/cmsPilotSlice';
import { recommendationsSlice }     from './dataReducers/recommendationsSlice';
import { configRegistrySlice }      from './dataReducers/configRegistrySlice';
import { formDataSlice }            from './dataReducers/formDataSlice';
import { applicationScopeSlice }    from './dataReducers/applicationScopeSlice';
import { useDispatch }              from 'react-redux';
import { applianceProfileSlice }    from './dataReducers/applianceProfileSlice';
import { homeProfileSlice }         from './dataReducers/homeProfileSlice';
import { pilotsSlice }              from './dataReducers/pilotsSlice';
import { recoCommentsSlice }        from './dataReducers/recoCommentsSlice';


const store = configureStore({
  reducer: {
    workflow : workflowSlice.reducer,
    cmsPilot : cmsPilotSlice.reducer,
    pilots : pilotsSlice.reducer,
    recommendations : recommendationsSlice.reducer,
    configRegistry : configRegistrySlice.reducer,
    formData : formDataSlice.reducer,
    applicationScope : applicationScopeSlice.reducer,
    applianceProfile : applianceProfileSlice.reducer,
    homeProfile : homeProfileSlice.reducer,
    recoComments : recoCommentsSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

export default store;